<template>
  <bc-select
    v-model="tags"
    :options="optionsMerged"
    @update:search-value="search"
    :on-select-option="selectOption"
  >
    <template #noresults>
      <li class="dropdown-item px-4 py-2 text-red-500">{{$t('Tag was not found')}}</li>
    </template>
    <template #option="slotProps">
      <li
        role="option"
        class="
          cursor-default
          select-none
          relative
          py-2
          pl-4
          pr-4
          truncate
          d-flex
        "
        :class="{
          'text-white bg-bc-blue': slotProps.highlighted,
          'text-gray-800': !slotProps.highlighted
        }"
        @mouseenter="slotProps.handleMouseEnter(slotProps.option)"
        @click.stop="slotProps.selectOption(slotProps.option)"
      >
        {{ slotProps.option.label }}
      </li>
    </template>

    <template #multitagselected="{ option, removeOption }">
      <div class="TableTags__Tag text-sm inline-flex items-center">
        <span class="">{{ option.label }} </span>
        <span
          class="cursor-pointer px-1"
          @click.prevent.stop="removeOption(option)"
          >&times;</span
        >
      </div>
    </template>
  </bc-select>
</template>
<script>
import { FileApi } from '../test-api/index.ts'
import axios from 'axios'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'

const fileApi = new FileApi({}, '/api/v2')
const CancelToken = axios.CancelToken
let cancelationToken

export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: Array,
    enabled: Boolean,
    id: String,
  },
  data() {
    return {
      options: [],
      q: null,
      tempTag: null,
      addedTags: []
    }
  },
  computed: {
    tags: {
      get() {
        return this.modelValue
      },
      set(newVal) {
        this.$emit('update:modelValue', newVal)
      }
    },
    controlItems() {
      return this.tags.map((tag) => {
        return {
          id: tag,
          label: tag
        }
      })
    },
    optionsMerged() {
      let mergedItems = [...this.options, ...this.addedTags, ...this.controlItems];
      if (this.tempTag) {
        mergedItems.push({
          id: this.tempTag,
          label: this.tempTag,
        })
      }
      return mergedItems;
    },
  },
  methods: {
    search(val) {
      if (!find(this.optionsMerged, ['id', val])) {
        this.tempTag = val;
      }

      if (val !== '') {
        this.addedTags = this.addedTags.filter((addedTag) => {
          return this.tags.includes(addedTag.id)
        })

        this.q = val
      }
    },
    selectOption(option, parentSelectOption) {
      if (option.id === this.tempTag) {
        this.addedTags.push({
          id: this.tempTag,
          label: this.tempTag,
        })

        this.tempTag = null
      } else if (!find(this.addedTags, ['id', option.id])) {
        this.addedTags.push(option)
      }
      
      const foundInOptions = findIndex(this.options, ['id', option.id])
      if (foundInOptions !== -1) {
        this.options.splice(foundInOptions, 1)
      }
      
      parentSelectOption(option)
    },
    async loadTags (val) {
      if (cancelationToken !== undefined) {
        cancelationToken.cancel();
        cancelationToken = undefined
      }

      try {
        cancelationToken = CancelToken.source()
        const tagsResponse = await fileApi.fileListTags(val || undefined, undefined, undefined, {
          cancelToken: cancelationToken.token
        })
        this.options = []
        tagsResponse.data.forEach((tag) => {
          if (!find(this.addedTags, ['id', tag]) && !find(this.controlItems, ['id', tag])) {
            this.options.push({
              id: tag,
              label: tag,
            })
          }
        })
      } catch (e) {
        // noop
      }
    }
  },
  watch: {
    q: {
      handler: function (val) {
        if (val) {
          this.loadTags(val)
        }
      }
    }
  }
}
</script>
